import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {slideInOut} from '../../animations/slide-in-out';
import {LayoutClassDirective} from '../../services/directives/layout-class.directive';

@Component({
	selector: 'app-action-bar',
	imports: [
		RouterOutlet,
		LayoutClassDirective
	],
	templateUrl: './action-bar.component.html',
	styleUrl: './action-bar.component.scss',
	animations: [
		slideInOut
	]
})
export class ActionBarComponent {
	activeComponent: Component | null = null;
	transition?: 'open' | 'close' | 'swap';

	onActivate(event: Component) {
		this.activeComponent = event;
		this.transition = 'open';
	}

	onDeactivate(event: Component) {
		this.activeComponent = null;
		this.transition = 'close';
	}
}
